// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const UserType = {
  "PRODUCER": "Producer",
  "INSTRUCTOR": "Instructor",
  "ADMINISTRATOR": "Administrator"
};

const DiagnoseType = {
  "VEGETATION_COVERAGE": "vegetationCoverage",
  "FLOWERING_RATE": "floweringRate",
  "BEARING_NUMBER": "bearingNumber",
  "BEARING_NUMBER_MEASURABLE": "bearingNumberMeasurable",
  "FRUIT_SIZE": "fruitSize",
  "FRUIT_MAX_SIZE": "fruitMaxSize",
  "FRUIT_MIN_SIZE": "fruitMinSize",
  "BRANCH_LENGTH": "branchLength"
};

const Category = {
  "FRUITS_THINNING": "fruitsThinning",
  "PESTICIDE_SPRAYNING": "pesticideSprayning",
  "MATING": "mating",
  "HARVEST": "harvest",
  "FLOWERING": "flowering",
  "OTHERS": "others"
};

const EventCategories = {
  "FRUITS_THINNING": "fruitsThinning",
  "PESTICIDE_SPRAYNING": "pesticideSprayning",
  "MATING": "mating",
  "HARVEST": "harvest",
  "FLOWERING": "flowering",
  "OTHERS": "others"
};

const Varieties = {
  "KOUSUI": "kousui",
  "HOUSUI": "housui",
  "AKIZUKI": "akizuki",
  "NIITAKA": "niitaka",
  "OTHERS": "others"
};

const { AppUser, UserGroup, Cooperation, Friendship, Farm, Photo, Diagnosis, DayDiagnosis, DiagnosisSummary, PhotoComment, DayDiagnoseComment, DailyLog, CultivationEvent, MonthReport, Message, Conversation, UserConversation, GroupConversation, SendPicture } = initSchema(schema);

export {
  AppUser,
  UserGroup,
  Cooperation,
  Friendship,
  Farm,
  Photo,
  Diagnosis,
  DayDiagnosis,
  DiagnosisSummary,
  PhotoComment,
  DayDiagnoseComment,
  DailyLog,
  CultivationEvent,
  MonthReport,
  Message,
  Conversation,
  UserConversation,
  GroupConversation,
  SendPicture,
  UserType,
  DiagnoseType,
  Category,
  EventCategories,
  Varieties
};